module.exports = __webpack_public_path__ + "static/media/ico-certificates.864bd7f1.svg";